import React, { useRef } from "react";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler,
  Title,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler,
  Title
);

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const GrossVolumeChart = () => {
  const { signUpUsers, filters } = useSelector((state) => state.dashboard);
  const chartRef = useRef();
  
  const year = filters?.fromDate
    ? new Date(filters.fromDate).getUTCFullYear()
    : new Date().getFullYear();

  const currentDate = new Date();
  const isCurrentYear = year === currentDate.getFullYear();
  const currentMonthIdx = currentDate.getMonth();

  const visibleMonths = isCurrentYear
    ? months.slice(0, currentMonthIdx + 1)
    : months;

  const chartData = {
    labels: visibleMonths,
    datasets: [
      // {
      //   label: "Free Plan",
      //   data: (signUpUsers?.freeTrialCounts || []).slice(0, visibleMonths.length),
      //   // fill: true,
      //   borderColor: "#6570fc",
      //   pointRadius: 0,
      //   tension: 0.4,
      //   backgroundColor: "#6570fc",
      // },
      {
        label: "Sign-Ups",
        data: (signUpUsers?.signupCounts || []).slice(0, visibleMonths.length),
        // fill: true,
        borderColor: "#c1c6fe",
        pointRadius: 0,
        tension: 0.4,
        backgroundColor: "#c1c6fe",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        yAlign: "bottom", // ✅ Puts tooltip *above* the point
        xAlign: "center",
        enabled: true,
        mode: "index",
        intersect: false,
        boxShadow: "1px 1px 3px rgba(0, 0, 0)", // Tooltip shadow
        backgroundColor: "#6570fc1a", // Tooltip background
        titleColor: "#000", // Title text color
        bodyColor: "#000", // Main text color
        // borderColor: "#00c49f", // Border color
        borderWidth: 1,
        cornerRadius: 6,
        padding: 14,
        titleFont: {
          size: 10,
          weight: "normal",
        },
        bodyFont: {
          size: 13,
          weight: "bold",
        },
        displayColors: false, // Hide color square
        callbacks: {
          label: (context) =>
            `${context?.dataset?.label}: ${context.parsed.y.toLocaleString()}`,
          title: (context) => `${context[0].label} ${year}`,
        },
      },
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        type: "linear",
        ticks: {
          // callback: (val) => `${val / 1000}k`,
          callback: (val) => val > 1000 ? `${val / 1000}k` : val,
          color: "#aaacae",
          padding: 16,
        },
        grid: {
          drawTicks: true,
          drawBorder: false,
          tickColor: "#0000",
          color: "#f0f0f0",
          borderDash: [20, 20],
        },
        border: {
          display: false,
        },
      },
      x: {
        ticks: {
          color: "#aaacae",
          padding: 16,
        },
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
    layout: {
      padding: {
        left: 16,
      },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%", padding: "0px" }}>
      <Line ref={chartRef} data={chartData} options={chartOptions} />
    </div>
  );
};

export default GrossVolumeChart;
